<template>
  <div class="container register">
    <v-card class="mt-12 regcard mx-auto" width="80%">
      <v-card-title
        class="loginmain justify-center text-white"
        style="font-size:24px;   font-family: 'Nunito', sans-serif;"
      >Verify Your Mobile Number</v-card-title>
      <div class="registercard">
        <v-card-text class="text-center">
          An OTP has been Sent to the Registered Mobile Number : {{number}}
          <v-btn text color="indigo darken-1">Change?</v-btn>
        </v-card-text>
        <div class="ml-12 mr-12 mt-8 text-center">
          <v-text-field
            class="otpnumber"
            type="number"
            required
            label="Enter OTP"
            v-model="otp"
            placeholder="Should Be 6 characters"
          />
          <v-card-text class="justify-center">
            <div class="justify-center form-inline">
              <v-checkbox class="check" v-model="approve" color="indigo"></v-checkbox>By clicking on Submit I agree to the
              <TermsConditions />&
              <PrivacyPolicy />
            </div>
            <div class="justify-center form-inline"></div>
          </v-card-text>

          <v-btn
            color="primary"
            class="login mb-12"
            :disabled="!approve"
            @click="handleSubmit"
            dark
          >
            Submit
          </v-btn>
          <v-btn
            color="primary"
            class="login mb-12 ml-4"
            @click="resend"
            dark
            v-if="!resending"
          >
            Resend OTP
          </v-btn>
          <v-progress-circular v-else indeterminate />

          <div class="text-center">
            <v-dialog v-model="dialog" width="500">
              <v-card>
                <v-card-title primary-title>Congrats Account Created</v-card-title>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <router-link to="/login">
                    <v-btn color="primary" text @click="dialog = false">OK</v-btn>
                  </router-link>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import {
  verifyOTP as verifyOTPService,
  resentOTP as resendOTPService
} from "../../services/register";
import TermsConditions from "@/views/Authentication/TermsConditions.vue";
import PrivacyPolicy from "@/views/Authentication/PrivacyPolicy.vue";
export default {
  components: {
    TermsConditions,
    PrivacyPolicy
  },
  data() {
    return {
      resending: false,
      dialog: false,
      otp: "",
      id: '',
      approve: true,
    };
  },
  computed: {
    number() {
      return this.$route.params.number;
    },
    userId(){
       return this.$route.params.userId;
    },
  },
  methods: {
    async handleSubmit() {
      try {
        const result = await verifyOTPService({
          otp: parseInt(this.otp),
          id: this.userId,
        });
        console.log("got result : ", result);
        this.$toasted.success("Registration successful", {
          duration: 2000
        });
        this.$router.push({
          name: "Login"
        });
      }
       catch (err) {
        console.log(err);
        this.$toasted.error("Something went wrong", {
          duration: 2000
        });
      }
    },
    async resend() {
      try {
        this.resending = true;
        await resendOTPService(this.number);
        this.$toasted.success('OTP is resent to your number', {
          duration: 2000
        });
        this.resending = false;
      }
      catch(err) {
        this.resending = false;
        console.log(err);
        this.$showError('Could not resend OTP');
      }
    }
  }
};
</script>
<style scoped>
.register {
  background-image: url("/img/authentication.jpg");
  background-size: cover;
  background-position: center;
  max-width: 100%;
  height: 100%;
}
.otpnumber {
  margin-left: 10rem !important;
  margin-right: 10rem !important;
}
@media (max-width: 768px) {
  .loginmain {
    font-size: 20px !important;
  }
  .otpnumber {
    margin-left: 2px !important;
    margin-right: 2px !important;
  }
}
.submit {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}
.check {
  margin-top: 20px;
}
</style>
